import { Dialog, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { WbCard } from '../../WbCard';
import { useGeneralPurposePickerContext } from '../GeneralPurposePickerContext';
import { GenericEntityType, Provider, TemplateEntity } from '../types';
import { ProviderFilters } from './CommonFilter';
import { MultiSelection } from './MultiSelection/MultiSelection';
import { SingleSelection } from './SingleSelection';
import { useId } from 'react';

export interface GeneralEntityPickerDialogProps {
  title: string;
  multiSelection?: boolean;
  providerMapper: Map<string, Provider<GenericEntityType[], ProviderFilters>>;
  availableKinds: TemplateEntity[];
  parentTemplateRef?: string;
}

export const GeneralEntityPickerDialog = (
  props: GeneralEntityPickerDialogProps,
) => {
  const { openDialog, setOpenDialog, setAiState, setErrorMessage } =
    useGeneralPurposePickerContext();

  const onDialogClose = () => {
    setOpenDialog(false);
    setAiState(false);
    setErrorMessage(undefined);
  };

  const titleId = useId();

  return (
    <Dialog
      open={openDialog}
      onClose={onDialogClose}
      maxWidth="xl"
      fullWidth
      aria-labelledby={titleId}
    >
      <WbCard
        titleId={titleId}
        title={props.title}
        cardStyle={{
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
          height: '70vh',
        }}
        actions={
          <IconButton aria-label="close" onClick={onDialogClose} size="small">
            <CloseIcon />
          </IconButton>
        }
      >
        {props.multiSelection ? (
          <MultiSelection
            {...props}
            parentTemplateRef={props.parentTemplateRef}
          />
        ) : (
          <SingleSelection
            {...props}
            parentTemplateRef={props.parentTemplateRef}
          />
        )}
      </WbCard>
    </Dialog>
  );
};
